export const DRAWER_FLOWS = {
  DEFAULT: 'default',
  FIT_OPTIONS: 'fitOptions',
  OOS_RECOMMENDATIONS: 'oosRecommendations'
};

export const OOS_RECOMMENDATIONS_LIMIT = 3;

const APPLIANCE_TYPES = [
  { keyword: 'dishwasher', label: 'Dishwashers', name: 'Dishwasher' },
  { keyword: 'refrigerator', label: 'Refrigerators', name: 'Refrigerator' },
  { keyword: 'freezer', label: 'Freezers', name: 'Freezer' },
  { keyword: 'microwave', label: 'Microwaves', name: 'Microwave' },
  { keyword: 'washer', label: 'Washers', name: 'Washer', exclude: 'dryer' },
  { keyword: 'washing machine', label: 'Washers', name: 'Washer', exclude: 'dryer' },
  { keyword: 'dryer', label: 'Dryers', name: 'Dryer', exclude: 'wash' },
  { keyword: 'range', label: 'Ranges', name: 'Range', exclude: 'hood' },
  { keyword: 'stove', label: 'Stoves', name: 'Stove' }
];

const getApplianceType = (categoryHierarchy) => {
  const labels = [...(categoryHierarchy || [])].reverse().map((label) => String(label).toLowerCase());
  return labels.reduce((found, label) => found || APPLIANCE_TYPES.find(
    ({ keyword, exclude }) => label.includes(keyword) && !(exclude && label.includes(exclude))
  ), null);
};

export const getApplianceLabel = (categoryHierarchy) => getApplianceType(categoryHierarchy)?.label || null;

const FLOW_CONTENT = {
  [DRAWER_FLOWS.FIT_OPTIONS]: {
    drawerHeading: 'Options That Fit',
    currentItemHeading: 'Current Item',
    differentItemHeading: 'Similar Items That Fit Your Space',
    emptyStateMessage: 'We\'re sorry, there are no similar items that fit your space.',
    showDoesNotFitBadge: true
  },
  [DRAWER_FLOWS.OOS_RECOMMENDATIONS]: ({ categoryHierarchy }) => {
    const { label, name = 'Item' } = getApplianceType(categoryHierarchy) || {};
    return {
      drawerHeading: label ? `Similar ${label}` : 'Similar Items',
      currentItemHeading: `Current ${name}`,
      differentItemHeading: `Select a Similar ${name}`,
      selectionButtonContent: `View ${name}`,
      emptyStateMessage: 'We\'re sorry, we couldn\'t find similar models available in your area right now.',
      showOutOfStockBadge: true,
      hideKPF: true,
      showDimensions: true
    };
  }
};

export const getFlowContent = (flow, { categoryHierarchy } = {}) => {
  const content = FLOW_CONTENT[flow];
  return (typeof content === 'function' ? content({ categoryHierarchy }) : content) || {};
};
